export enum SearchReturnType {
    RecentItems,
    SearchResult,
}

// export enum SortValEnum { //lower case enum of all types + other
//     text = 1,
//     note = 2,
//     number = 3,
//     currency = 4,
//     numberpercentage = 5,
//     choice = 6,
//     multichoice = 7,
//     lookupsingle = 8,
//     lookupmulti = 9,
//     taxonomyfieldtype = 10,
//     taxonomyfieldtypemulti = 11,
//     datetime = 12,
//     user = 13,
//     usermulti = 14,
//     url = 15,
//     boolean = 16,
//     other = 17,
// }
export const SortValEnum = { //lower case enum-like object (supporting duplicate values) of all types + other
    text: 1,
    note: 2,
    number: 3,
    currency: 4,
    numberpercentage: 5,
    choice: 6,
    multichoice: 6,
    lookupsingle: 7,
    lookupmulti: 7,
    taxonomyfieldtype: 8,
    taxonomyfieldtypemulti: 8,
    datetime: 9,
    user: 10,
    usermulti: 10,
    url: 11,
    boolean: 12,
    other: 13,
}